export const guestDescription = (
  adultCount: number,
  childCount: number,
  infantCount: number,
  petCount: number
) => {
  const totalGuest = adultCount + childCount + infantCount + petCount;

  if (totalGuest < 1) {
    return '';
  }

  const adultDescription = `${adultCount} guest${adultCount > 1 ? 's' : ''}`;
  const childDescription = `${childCount} ${
    childCount > 1 ? 'children' : 'child'
  }`;
  const infantDescription = `${infantCount} infant${
    infantCount > 1 ? 's' : ''
  }`;
  const petDescription = `${petCount} pet${petCount > 1 ? 's' : ''}`;

  let description = '';

  if (adultCount !== 0) {
    description = adultDescription;
  }

  if (childCount !== 0) {
    if (description.length !== 0) {
      description = description + ', ' + childDescription;
    } else {
      description = childDescription;
    }
  }

  if (infantCount !== 0) {
    if (description.length !== 0) {
      description = description + ', ' + infantDescription;
    } else {
      description = infantDescription;
    }
  }

  if (petCount !== 0) {
    if (description.length !== 0) {
      description = description + ', ' + petDescription;
    } else {
      description = petDescription;
    }
  }

  return description;
};
